import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedUiMaterialModule } from '@digilize/shared/ui/material/src';

import { OrderControlComponent } from './order-control/order-control.component';
import { SelectComponent } from './select/select.component';
import { InlineSVGModule } from '@digilize/shared/ui/inline-svg/src';

const COMPONENTS = [SelectComponent, OrderControlComponent];

@NgModule({
  declarations: [COMPONENTS],
  imports: [CommonModule, SharedUiMaterialModule, InlineSVGModule],
  exports: [COMPONENTS],
})
export class LanguageSchoolUiModule {}
